{
  "page": {
    "title": "Promotion report"
  },
  "column": {
    "sku": "SKU",
    "product_name": "Product name",
    "marketplace": "Marketplace",
    "quota": "Quota",
    "used": "Used",
    "remaining": "Remaining",
    "seller": "Seller"
  },
  "action": {
    "export_xlsx": "Export .xlsx"
  }
}
